import { Component, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject, take, takeUntil } from "rxjs";
import { AuthenticationService } from '@core/services';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: './info-confirm-email-sent.component.html',
  styleUrls: ['./info-confirm-email-email-sent.component.css']
})
export class ConfirmEmailSentInfoComponent implements OnDestroy {

  public email: string;
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private toastService: ToastrService,
    private translate: TranslateService,
  ) {
    this.route.queryParams
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(params => {
        if (params.email) {
          this.email = params.email;
        } else {
          this.router.navigate(['/sign-in']);
        }
      }
      );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public sendConfirmationEmail(): void {
    this.authService.sendConfirmationEmail(this.email)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.toastService.success(this.translate.instant('general.confirm_email_sent'), this.translate.instant('general.success_message'));
        },
        error: err => {
          this.toastService.error(err, this.translate.instant('general.error_message'));
        }
      });
  }
}
